import { useQuery } from '@tanstack/react-query';

import type { UseQueryResult } from '@tanstack/react-query';
import type { MacroInformation } from '../types';

import { apiClient } from '@config/server/apiClient';
import { configurationEndpoints } from '@config/server/apiEndpoints';

import { aiBdc } from './queryKeys';

async function fetchMacroInformation(spId: string): Promise<MacroInformation | null> {
	const response = await apiClient.get<{ success: boolean; data: MacroInformation | null }>(
		configurationEndpoints.macroInfo(spId),
	);
	return response.data?.data ?? null;
}

export const useGetMacroInformation = (
	spId: string,
): UseQueryResult<MacroInformation | null> =>
	useQuery({
		...aiBdc.macroInformation(spId),
		queryFn: () => fetchMacroInformation(spId),
		staleTime: 5 * 60 * 1000,
	});
